// listas-20261022: lista blanca de WhatsApp (solo admin / super_admin)
import { useCallback, useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { getPizasWaWhitelist, updatePizasWaWhitelist } from '../lib/api';
import { entriesFromApi } from '../lib/waBlacklistUtils';
import PhoneListEditor from './PhoneListEditor';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Switch } from './ui/switch';
import { Label } from './ui/label';

export default function WaWhitelistCard() {
  const [enabled, setEnabled] = useState(false);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const apply = (d) => {
    setEnabled(Boolean(d?.enabled));
    setEntries(entriesFromApi({ entries: d?.entries || [] }));
  };
  const load = useCallback(async () => {
    try {
      apply(await getPizasWaWhitelist());
    } catch {
      toast.error('No se pudo cargar la lista blanca.');
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (v) => {
    if (v && entries.length === 0) {
      toast.warning('Lista vacía: con la lista blanca activa el bot no contestará a nadie.');
    }
    try {
      apply(await updatePizasWaWhitelist({ enabled: v }));
      toast.success(v ? 'Lista blanca activada' : 'Lista blanca desactivada');
    } catch {
      toast.error('No se pudo guardar.');
    }
  };

  return (
    <Card className="max-w-xl border border-border" data-testid="wa-whitelist-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <ShieldCheck className="w-5 h-5 text-primary" />
          Lista blanca WhatsApp
        </CardTitle>
        <CardDescription>
          Activada: el bot solo contesta a estos números; a los demás no les responde ni marca leído. Los avisos
          de un pedido (liga de pago, pedir ubicación, ubicación de sucursal) se envían siempre, y la ubicación que
          un cliente comparte para su pedido telefónico se acepta aunque no esté en la lista.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">
        {loading ? (
          <p className="text-sm text-muted-foreground animate-pulse">Cargando…</p>
        ) : (
          <>
            <div className="flex items-center justify-between rounded-md border border-border p-3">
              <Label htmlFor="wa_wl_on" className="text-sm font-medium">
                {enabled ? 'Activada: solo números de la lista' : 'Desactivada: el bot contesta a todos'}
              </Label>
              <Switch id="wa_wl_on" checked={enabled} onCheckedChange={toggle} data-testid="wa-whitelist-switch" />
            </div>
            <PhoneListEditor
              idPrefix="wa_wl"
              entries={entries}
              emptyText="Sin números en la lista blanca."
              onChange={async (next) => apply(await updatePizasWaWhitelist({ entries: next }))}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
}
